export default "__VITE_ASSET__1334de8b__"